// extracted by mini-css-extract-plugin
export var link = "_qq-0";